import RemInit from '@livelybone/rem-init'
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  format,
  parse,
} from 'date-fns'
import * as config from '../../config/config'
import AuthToken from '../extensions/AuthToken'
import Http from '../extensions/Http'
import { getLang, langs, setLang } from '../extensions/Langs'
import { joinUrl } from '../utils/request-deal'

/**
 * 站点信息
 * */
export const SiteMixin = {
  created() {
    const siteInfo = window.INIT_STATE && window.INIT_STATE.siteInfo || {}
    const arr = (siteInfo.privilages || '').split(',')
    this.siteInfo = {
      ...siteInfo,
      c2cEnabled: arr.includes('4'),
      otcEnabled: arr.includes('8'),
    }
    this.setIco()
  },
  data() {
    return {
      siteInfo: {},
    }
  },
  methods: {
    setIco() {
      if (typeof window !== 'undefined') {
        const ico = document.createElement('link')
        ico.setAttribute('rel', 'shortcut icon')
        ico.setAttribute('href', this.siteInfo.icon)
        document.head.appendChild(ico)
      }
    },
  },
}

/**
 * 多语言设置，当前语言获取
 * */
const langObj = { lang: '' }
export const LangMixin = {
  beforeMount() {
    this.getLang()
  },
  data() {
    return {
      langs,
      langObj,
    }
  },
  computed: {
    lang() {
      return this.langObj.lang
    },
  },
  watch: {
    lang(val) {
      this.setLang(val).then((res) => {
        if (res) console.log(res)
        this.getLang()
      }).catch(console.error)
    },
  },
  methods: {
    getLang() {
      return getLang()
        .then((val) => {
          this.langObj.lang = val
          return val
        })
        .catch(console.error)
    },
    setLang,
    $t(source, key) {
      return this.lang ? source[this.lang][key] || key : key
    },
  },
}

/**
 * Http 请求封装，另含两个接口方法
 * @method getUserInfo 获取用户信息
 * @method signOut 登出
 * */
export const HttpMixin = {
  created() {
    AuthToken.tokenChange.subscribe((token, expired) => {
      if (expired) {
        this.snackbar.error('Your token has been expired, page will refresh!')
        setTimeout(() => {
          this.signOut()
        }, 1000)
      } else if (!token) {
        this.signOut()
      } else {
        console.log('token 失效')
      }
    })
  },
  data() {
    return {
      Http,
      userInfo: {},
    }
  },
  methods: {
    getUserInfo() {
      return this.Http.get(this.mainUrl('/user')).then((res) => {
        this.userInfo = {
          ...res,
          username: res.username || res.phone || res.email,
        }
      }).catch((err) => {
        console.error(err)

        const status = err.statusCode || err.status
        console.log(status, ':status')
        if (status === 401 || status === 400) AuthToken.setToken('')
      })
    },
    signOut() {
      console.log('signOut')
      AuthToken.setToken('')
      // window.location.reload()
    },
    queryString(queryParams) {
      return queryParams ? Object.keys(queryParams).reduce((pre, key) => `${pre}&${key}=${queryParams[key]}`, '') : ''
    },
    goSignIn(query = null) {
      window.location.href = `${window.location.origin}${window.isMobile ? '/mobile' : ''}/sign-in?redirectTo=${encodeURIComponent(window.location.href)}${this.queryString(query)}`
    },
    goSignUp(query = null) {
      window.location.href = `${window.location.origin}${window.isMobile ? '' : '/sign-up'}?redirectTo=${encodeURIComponent(window.location.href)}${this.queryString(query)}`
    },
    goTo(url) {
      window.location.href = url
    },
    goBack() {
      window.history.back()
    },
    goForward() {
      window.history.forward()
    },
    mainUrl(url) {
      let { origin } = window.location
      const uri = joinUrl(config.mainBackendUrl, url)
      if (/^https?:\/\//.test(uri)) {
        origin = ''
      }
      return origin ? joinUrl(origin, uri) : uri
    },
    mainUrl2(url) {
      let { origin } = window.location
      const uri = joinUrl(config.goBackendUrl, url)
      if (/^https?:\/\//.test(uri)) {
        origin = ''
      }
      return origin ? joinUrl(origin, uri) : uri
    },
    mainUrl4(url) {
      let { origin } = window.location
      const uri = joinUrl(config.phpBackendUrl, url)
      if (/^https?:\/\//.test(uri)) {
        origin = ''
      }
      return origin ? joinUrl(origin, uri) : uri
    },
    mainUrl3(url) {
      let { origin } = window.location
      const uri = joinUrl(config.backendUrl3, url)
      if (/^https?:\/\//.test(uri)) {
        origin = ''
      }
      return origin ? joinUrl(origin, uri) : uri
    },
    easyMock(url) {
      let { origin } = window.location
      const uri = joinUrl(config.easyMock, url)
      if (/^https?:\/\//.test(uri)) {
        origin = ''
      }
      return origin ? joinUrl(origin, uri) : uri
    },
  },
}

/**
 *  一进去页面判断token存不存在
 * * */
export const GetToken = {
  methods: {
    getToken() {
      // console.log(window.getUserToken.token, 'A')
      try {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          this.tokens = window.getUserToken.token
        } else if (/(Android)/i.test(navigator.userAgent)) {
          this.tokens = JSON.parse(window.invite_callback.getUserToken()).token
        } else {
          this.tokens = localStorage.getItem('AUTH_TOKEN')
        }
        if (this.tokens) {
          this.setToken(this.tokens)
        }
      } catch (e) {
        console.log('网页端', e)
      }
      // this.userUserLogin()
    },
    setToken(t) {
      if (t !== '') {
        localStorage.setItem('AUTH_TOKEN', t)
        localStorage.setItem('EXPIRE', (Date.now() + 100000000).toString())
      }
    },
  },
  data() {
    return {
      tokens: '',
    }
  },
}

/**
 * 全局 snackbar 组件
 * */
export const SnackbarMixin = {
  created() {
    this.snackbar = window.snackbar
  },
  data() {
    return {
      snackbar: null,
    }
  },
}

/**
 * 静态文件处理
 * */
export const SourceMixin = {
  methods: {
    source(url) {
      return joinUrl(config.ossUrl, url)
    },
  },
}

/**
 * @method dFormatter 时间格式化
 * @method timeDelta 指定时间到当前时间的增量
 * */
export const TimeMixin = {
  methods: {
    dFormatter(time, fmt = 'YYYY-MM-DD HH:mm:ss') {
      let t = 0
      if (+time) t = time * 1000
      return format(parse(t || time), fmt)
    },
    timeDelta(time) {
      // time 毫秒数
      const d = parse(time)
      const now = new Date()
      return {
        day: Math.floor(differenceInDays(d, now)),
        hour: differenceInHours(d, now) % 24,
        minute: differenceInMinutes(d, now) % 60,
        second: differenceInSeconds(d, now) % 60,
      }
    },
  },
}

/**
 * 获取路由?后参数
 * */
export const routerMixin = {
  methods: {
    getQuery(key) {
      const search = String(window.location.search).slice(1).split('=')
      let value = 0
      search.forEach((item, i) => {
        if (item === key) {
          value = search[i + 1]
        }
      })
      return value
    },
  },
}

export const CommonMixins = [
  SiteMixin,
  LangMixin,
  HttpMixin,
  SnackbarMixin,
  SourceMixin,
  TimeMixin,
  routerMixin,
  GetToken,
]

/**
 * 页面标题设置，只需要在页面文件中引用
 * */
export const TitleMixin = {
  beforeMount() {
    this.setTitle()
  },
  watch: {
    title() {
      this.setTitle()
    },
  },
  methods: {
    setTitle() {
      if (!this.title) throw new Error('Please set title attribute in data')
      else document.title = this.title
    },
  },
}

/**
 * viewport 设置, 请在 beforeCreate 钩子中使用
 * @param {Boolean} specialScale, 针对 pc 端页面需要设置为 true，用于确保手机访问正常，针对 mobile 端的页面设置为 false
 * */
export function setViewport(specialScale = false) {
  RemInit({
    pageScalable: true,
    pageScaleMaxFactor: true,
    pageScaleMiddleware(fontScale) {
      if (fontScale === 1 || !specialScale) return 1 / fontScale
      return 1 / fontScale / fontScale / (1280 / fontScale / window.screen.availWidth)
    },
  })
}
